import React, { useEffect, useState } from 'react';
import type { TransparencyDashboardStats } from '@yawi/types';
import { TransparencyProjectStatus } from '@yawi/types';
import { useServices } from '@/app/providers';
import { KpiCard } from '../../../../presentation/components/organisms/admin-v2/KpiCard';

/**
 * Fila de KPIs sobre la tabla. Consume el endpoint dashboard/stats que ya
 * existía sin consumidor visual desde v1.
 */
export const ProjectKpiRow: React.FC<{ refreshKey?: number }> = ({ refreshKey }) => {
  const { transparencyProjectRepo } = useServices();
  const [stats, setStats] = useState<TransparencyDashboardStats | null>(null);

  useEffect(() => {
    let cancelled = false;
    transparencyProjectRepo
      .getDashboardStats()
      .then((s) => {
        if (!cancelled) setStats(s);
      })
      .catch(() => {
        // Silencioso: los KPIs son complementarios, la tabla es lo esencial.
      });
    return () => {
      cancelled = true;
    };
  }, [transparencyProjectRepo, refreshKey]);

  if (!stats) return null;

  const inProgress = stats.byStatus[TransparencyProjectStatus.IN_PROGRESS] ?? 0;
  const completed = stats.byStatus[TransparencyProjectStatus.COMPLETED] ?? 0;
  const delayed = stats.byStatus[TransparencyProjectStatus.DELAYED] ?? 0;

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 mb-4">
      <KpiCard title="Proyectos" value={String(stats.total)} />
      <KpiCard title="En progreso" value={String(inProgress)} />
      <KpiCard title="Completados" value={String(completed)} subValue={`${stats.completionRate}% del total`} />
      <KpiCard
        title="Retrasados"
        value={String(delayed)}
        delta={delayed > 0 ? 'Requieren atención' : undefined}
        deltaPositive={false}
      />
      <KpiCard title="Avance promedio" value={`${stats.averageProgress}%`} />
    </div>
  );
};
